<!--
    购物车样品
 -->
<template>
  <div>
    <div class="shopping-select">
      <el-table :data="selectList" @selection-change="handleSelectionChange" :row-class-name="rowClassName" :header-cell-class-name="headerStyle">
        <el-table-column label="客户名称">
          <template v-slot="scope">
            <div @click="editNameDialog = true, editNameInfo = { name: scope.row.name, index: scope.row.index, itemSpuId: scope.row.itemSpuId }" class="edit-outline">
              <!-- <img src="../../assets/images/editOutline.png" alt=""> -->
              <span style="max-width: 320px;">{{ scope.row.name }}</span>
              <span class="editBtn">编辑</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货地址" width="400">
          <template v-slot="scope">
            <div @click="addAddress(scope.row, scope.$index)" class="edit-outline">
              <!-- <img src="../../assets/images/editOutline.png" alt=""> -->
              <span :style="!scope.row.address ? 'color:red;' : ''" style="max-width: 320px;">{{ scope.row.address ? scope.row.address.completeAddress : '暂无地址' }}</span>
              <span class="editBtn">编辑</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="num" width="110">
          <template v-slot="scope">
            <!-- <el-input-number v-model="scope.row.num" :min="1" :step="1" size="mini" @change="(val) => { return chanegNum(val, scope) }"></el-input-number>  -->
            <div style="text-align: center;">{{ scope.row.num }} </div>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="150">
          <template v-slot="scope">
            <span class="color-blue">￥{{ scope.row.priceRel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="260">
          <template v-slot="scope">
            <span class="table_btn" style="float:right !important;">{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加收货地址 -->
    <AddAddress ref="addressRef" @changeAddress="changeAddress" @getList="getAddressList"></AddAddress>
    <!-- 修改客户备注 -->
    <el-dialog :close-on-click-modal="false" title="客户名称" :visible.sync="editNameDialog" width="30%">
      <el-input v-model.trim="editNameInfo.name" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editNameDialog = false" round>取 消</el-button>
        <el-button type="primary" round @click="editName">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除购物车子项 -->
    <el-dialog :close-on-click-modal="false" title="重要提示" :visible.sync="deleteItemDialog" width="30%">
      <span>确认删除该产品？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteItemDialog = false" round>取 消</el-button>
        <el-button type="primary" round @click="deleteData()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import AddAddress from '../AddAddressDialog/index.vue'
import { addressGetAddressById, copyAddressById, addressGetAddressByStoreId, saveDimAddressFromExcel, wxLogSave } from '@/api/crm'
import { cartItemSpuRemove, cartItemSpuMessage, cartItemSpuQuantity, cartItemSpuChangeAddress, cartItemSample } from '@/api/oms'

export default {
  name: 'DndList',
  components: {
    AddAddress
  },
  props: ['skuGroupMsg'],
  data () {
    return {
      loading: null,
      SampleNum: 0,
      editNameInfo: {
        name: '',
        id: '',
        itemSpuId: ''
      },
      editNameDialog: false,
      deleteType: '',
      deleteItem: '',
      deleteItemDialog: false,
      storeDefaultAddress: {},
      progress: 0,
      nowUser: '',
      updateShow: false,
      falgs: 'article',
      disabled: false,
      list1: [],
      acceptList: [],
      selectList: [],
      lastenter: '', // 是否为一个文件夹
      imgEnter: true, // 是否为图片格式
      draggableList: {},
      skuRuleList: [],
      skuRuleMsg: {},
      multipleSelection: [],
      awsSdk: {},
      timer: null,
      userType: localStorage.getItem('userType')
    }
  },
  watch: {
    skuGroupMsg: {
      handler (val, oldVal) {
        console.log('value', val)
      },
      deep: true,
      immediate: false
    }
  },
  created () {
    this.loadImg()
  },
  methods: {
    watch (val) {
      // error判定
      // 算总价格
      let allPrice = 0
      let allRealPrice = 0
      let allBookNum = 0
      let uploadedUser = 0
      val.forEach((user, index) => {
        allPrice += +user.price
        allRealPrice += +user.priceRel
        allBookNum += +user.num
        uploadedUser += user.itemSpuId ? 1 : 0
      })
      if (this.$route.path === '/cart') {
        let data = {
          allUserPrice: allPrice.toFixed(2),
          allUserRealPrice: (allRealPrice).toFixed(2),
          allBookNum,
          uploadedUser,
          allUserNum: val.length
        }
        console.log('向父组件传值')
        // 向父组件传值
        this.$emit('changeSpuData', data)
      }
    },
    // async setCartItemSample (address, addressId, name, error) {
    //   let { skuGroupId, skuId, spuId, price } = this.selectList[0]
    //   let cartItem = {
    //     addressId: addressId,
    //     channel: 'B2B',
    //     sample: false,
    //     normal: true,
    //     memo: name,
    //     price: price,
    //     skuGroupId: skuGroupId,
    //     skuId: skuId,
    //     spuId: spuId,
    //     spuType: false,
    //     series: false,
    //     storeId: this.$store.state.user.storeId,
    //     itemType: 'NORMAL',
    //     originType: 'WEB'
    //   }
    //   await cartItemSample(cartItem).then(res => {
    //     if (res.data.success) {
    //       this.SampleNum++
    //       let user = res.data.data[0]
    //       // this.skuGroupMsg.spus.push(user)
    //       let userObj = {
    //         spuId: user.spuId,
    //         skuId: user.skuId,
    //         skuGroupId: user.skuGroupId,
    //         itemSpuId: user.itemSpuId,
    //         status: false,
    //         remark: user.remark,
    //         name: name,
    //         address: error ? '' : address || null,
    //         num: user.quantity,
    //         oncePrice: user.price,
    //         price: (user.price * user.quantity).toFixed(2),
    //         addressError: error
    //       }
    //       this.selectList.push(userObj)
    //       this.watch(this.selectList)
    //       this.$emit('syncProData', res.data.data[0], 'add')
    //     }
    //   })
    // },
    remarkDailog (index) {
      // sessionStorage.setItem("pageAddressType", 'SampleUsers')
      this.$refs.ChoiceAddress.show(index)
    },
    headerStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 4) {
        return 'right-align'
      }
      if (columnIndex === 2) {
        return 'margin-align'
      }
    },
    checkSave () {
      if (
        this.selectList.some(user => {
          return !user.address
        })
      ) {
        return 'user:address:null'
      } else {
        return false
      }
    },
    // 改名字
    editName () {
      if (!this.editNameInfo.name) {
        this.$notify({
          title: '失败',
          message: '请输入客户名称',
          type: 'error'
        })
        return
      }
      cartItemSpuMessage({ itemSpuId: this.editNameInfo.itemSpuId, message: this.editNameInfo.name }).then(res => {
        if (res.data.success) {
          this.$emit('syncProData', this.editNameInfo, 'editName')
          this.selectList[this.editNameInfo.index].name = this.editNameInfo.name
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
        }
      })
      this.editNameDialog = false
      this.$forceUpdate()
    },
    // 计算本数
    handleAllAmount () {
      let allPrice = 0
      let allRealPrice = 0
      let allBookNum = 0
      let uploadedUser = 0
      this.selectList.forEach(user => {
        allPrice += +user.price
        allRealPrice += +user.priceRel
        allBookNum += +user.num
        uploadedUser += user.itemSpuId ? 1 : 0
      })
      let data = {
        allUserPrice: (allPrice).toFixed(2),
        allUserRealPrice: (allRealPrice).toFixed(2),
        allBookNum,
        uploadedUser,
        allUserNum: this.selectList.length
      }
      // 向父组件传值
      this.$emit('changeSpuData', data)
    },
    // 加载已保存的用户
    loadImg () {
      let num = 0
      console.log('this.skuGroupMsg.spus', this.skuGroupMsg.spus)
      this.skuGroupMsg.spus.forEach((user, index) => {
        if (user.addressId) {
          addressGetAddressById(user.addressId).then(res => {
            num++
            let oncePrice = user.samplePrice
            let onceRelPrice = user.sampleRealPrice / user.quantity
            console.log('oncePrice-user', user)

            let userObj = {
              spuId: user.spuId,
              skuId: user.skuId,
              skuGroupId: user.skuGroupId,
              itemSpuId: user.itemSpuId,
              status: false,
              remark: user.remark,
              name: user.memo,
              address: res.data.success ? res.data.data : null,
              num: user.quantity,
              oncePrice: oncePrice,
              onceRelPrice: onceRelPrice,
              priceRel: (onceRelPrice * user.quantity).toFixed(2),
              price: (oncePrice * user.quantity).toFixed(2)
            }
            this.selectList.push(userObj)
            if (num === this.skuGroupMsg.spus.length) {
              this.handleAllAmount()
            }
          })
        } else {
          num++
          // let oncePrice = !this.skuGroupMsg.sample ? JSON.stringify(this.skuGroupMsg.skuGroupInfo.sku.specialPriceDTO) !== '{}' ? this.skuGroupMsg.skuGroupInfo.sku.specialPriceDTO.applyType === 'APPLY_BASE' ? this.skuGroupMsg.skuGroupInfo.sku.specialPriceDTO.price : '未定义' : user.price : this.skuGroupMsg.skuGroupInfo.samplePrice
          let oncePrice = user.skus[0].samplePrice
          let onceRelPrice = user.skus[0].sampleRealPrice / user.skus[0].quantity
          console.log('oncePrice-2', oncePrice)
          let userObj = {
            spuId: user.spuId,
            skuId: user.skuId,
            skuGroupId: user.skuGroupId,
            itemSpuId: user.itemSpuId,
            status: false,
            remark: user.remark,
            name: user.memo,
            address: null,
            num: user.quantity,
            oncePrice: oncePrice,
            onceRelPrice: onceRelPrice,
            priceRel: (onceRelPrice * user.quantity).toFixed(2),
            price: (oncePrice * user.quantity).toFixed(2)
          }
          this.selectList.push(userObj)
          if (num === this.skuGroupMsg.spus.length) {
            this.handleAllAmount()
          }
        }
      })
    },
    getStoreAddress () {
      addressGetAddressByStoreId(this.$store.state.user.storeId).then(res => {
        if (res.data.success) {
          copyAddressById(res.data.data.id).then(res => {
            if (res.data.success) {
              this.storeDefaultAddress = res.data.data
              this.$forceUpdate()
            }
          })
        }
      })
    },
    addAddress (item, index) {
      console.log('item', item, index)
      this.$refs.addressRef.show('edit', item.address, index)
    },
    async changeAddress (index, val) {
      if (index === 'all') {
        let num = 0
        this.selectList.forEach(async (item, index) => {
          item.address = val
          if (item.itemSpuId) {
            await cartItemSpuChangeAddress({
              addressId: this.selectList[index].address.id,
              itemSpuId: this.selectList[index].itemSpuId,
              params: { addressId: this.selectList[index].address.id }
            }).then(res => {
              if (res.data.success) {
                num++
                if (num === this.selectList.length) {
                  this.$notify({
                    title: '成功',
                    message: '地址修改成功',
                    type: 'success'
                  })
                }
              }
            })
          }
        })
      } else {
        this.selectList[index].address = val
        if (this.selectList[index].itemSpuId) {
          await cartItemSpuChangeAddress({
            addressId: this.selectList[index].address.id,
            itemSpuId: this.selectList[index].itemSpuId,
            params: { addressId: this.selectList[index].address.id }
          }).then(res => {
            if (res.data.success) {
              this.selectList[index].addressError = false
              this.$notify({
                title: '成功',
                message: '地址修改成功',
                type: 'success'
              })
              this.$emit('syncProData', this.selectList[index], 'editAddress')
            }
          })
        }
      }
      console.log('1323435')
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    async chanegNum (val, scope) {
      // if (this.timer !== null) {
      //   clearTimeout(this.timer)
      //   this.timer = null
      // }
      // this.timer = setTimeout(() => {
      await cartItemSpuQuantity({ itemSpuId: scope.row.itemSpuId, nums: scope.row.num }).then(res => {
        if (res.data.success) {
          this.$emit('syncProData', scope.row, 'editNum')
          this.selectList[scope.$index].price = (this.selectList[scope.$index].oncePrice * val).toFixed(2)
          this.selectList[scope.$index].priceRel = (this.selectList[scope.$index].onceRelPrice * val).toFixed(2)
          this.handleAllAmount()
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
        }
      })
      // }, 500)
      // const loading = this.$loading({
      //   lock: true,
      //   text: '',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // cartItemSpuQuantity({ itemSpuId: scope.row.itemSpuId, nums: scope.row.num }).then(res => {
      //   loading.close()
      //   if (res.data.success) {
      //     this.$emit('syncProData', scope.row, 'editNum')
      //     this.selectList[scope.$index].price = (this.selectList[scope.$index].oncePrice * val).toFixed(2)
      //     this.handleAllAmount()
      //     this.$notify({
      //       title: '成功',
      //       message: '修改成功',
      //       type: 'success'
      //     })
      //   }
      // })
    },
    deleteData () {
      if (this.deleteType === 'ALL') {
        let spuIds = []
        this.selectList.forEach(user => {
          if (user.itemSpuId) {
            spuIds.push(user.itemSpuId)
          }
        })
        if (spuIds.length !== 0) {
          spuIds = spuIds.join(',')
          cartItemSpuRemove({ itemId: this.skuGroupMsg.cartItemId, spuIds }).then(res => {
            if (res.data.success) {
              this.selectList.length = 0
              this.handleAllAmount()
              this.deleteItemDialog = false
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              })
            }
          })
        } else {
          this.selectList.length = 0
          this.handleAllAmount()
          this.deleteItemDialog = false
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success'
          })
        }
      } else if (this.deleteType === 'ONCE') {
        if (this.deleteItem.row.itemSpuId) {
          cartItemSpuRemove({ itemId: this.skuGroupMsg.cartItemId, spuIds: '' + this.deleteItem.row.itemSpuId }).then(res => {
            if (res.data.success) {
              this.selectList.splice(this.deleteItem.$index, 1)
              this.handleAllAmount()
              this.$emit('syncProData', this.deleteItem.row.itemSpuId, 'deleteOnce')
              this.deleteItemDialog = false
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              })
            }
          })
        } else {
          this.selectList.splice(this.deleteItem.$index, 1)
          this.handleAllAmount()
          this.deleteItemDialog = false
        }
      }
    },
    // remarkDailog (type, row) {
    //   this.$refs.ChoiceAddress.show(row.index)
    // },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getAddressList () {
      this.$refs.ChoiceAddress.getAddressList()
    },
    // 页面关闭
    handleBeforeUnload () {
      console.log('-----------监听页面关闭事件')
      let info = {
        userId: this.$store.state.user.userId,
        info: '没有修改上传完成excel表格页面刷新'
      }
      let val = {
        identity: Date.now(),
        info: JSON.stringify(info)
      }
      wxLogSave(val)
    }
    // 通货产品上传的excel数据
    // async filechange (value) {
    //   console.log('通货')
    //   this.addressListLeng = value.length
    //   if (value.length < this.selectList.length) {
    //     this.$message.error('地址数量与产品数量不匹配')
    //     return
    //   }
    //   let a = 0
    //   this.loading = this.$loading({
    //     lock: true,
    //     text: '正在上传excel数据，请勿关闭页面',
    //     spTEXT: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })
    //   window.addEventListener('beforeunload', this.handleBeforeUnload)
    //   console.log('value', value, 'this.selectList', this.selectList)
    //   this.SampleNum = this.selectList.length
    //   // let num = value.length - this.SampleNum
    //   // if (num > 0) {
    //   //   for (let i = 0; i < num; i++) {
    //   //     console.log('iiiiiii++', i)
    //   //     this.setCartItemSample()
    //   //   }
    //   //   if (this.SampleNum === value.length) {
    //   //     console.log('this.SampleNum', this.SampleNum)
    //   //   }
    //   // }
    //   // let tableList = this.selectList
    //   // value.forEach(item => {
    //   for (let i in value) {
    //     let item = value[i]
    //     let selectListItem = this.selectList[i]
    //     // 地址表中有10条，这里也要补全10条，将现有的需要修改地址的修改地址
    //     if (selectListItem) {
    //       if (selectListItem.name !== item.person) {
    //         // 修改客户名称
    //         let aaa = await cartItemSpuMessage({ itemSpuId: this.selectList[i].itemSpuId, message: item.person })
    //         if (aaa.data.success) {
    //           this.selectList[i].name = item.person
    //           this.$emit('syncProData', this.selectList[i], 'editName')
    //         }
    //       }
    //       if (selectListItem.address?.completeAddress !== item.completeAddress) {
    //         // 获取数据库返回的地址
    //         let address = await saveDimAddressFromExcel(item)
    //         let addressId = 0
    //         if (address.data.success) {
    //           addressId = address?.data?.data?.id
    //           this.selectList[i].addressError = false
    //         } else {
    //           addressId = 0
    //           this.selectList[i].addressError = true
    //         }
    //         if (selectListItem.itemSpuId) {
    //           // 修改地址
    //           let newdata = await cartItemSpuChangeAddress({
    //             addressId: addressId,
    //             itemSpuId: this.selectList[i].itemSpuId,
    //             params: { addressId: addressId }
    //           })
    //           // 修改成功
    //           if (newdata.data.success) {
    //             this.selectList[i].address = address?.data?.data
    //             this.$emit('syncProData', this.selectList[i], 'editAddress')
    //           } else {
    //             // 没有修改成功
    //             this.selectList[i].address = ''
    //             this.selectList[i].addressError = true
    //             this.$emit('syncProData', this.selectList[i], 'editAddress')
    //           }
    //         }
    //       }
    //     } else {
    //       // 修改地址，获取到地址Id
    //       let address = await saveDimAddressFromExcel(item)
    //       let addressId = ''
    //       let addressError = false
    //       if (address.data.success) {
    //         addressId = address?.data?.data?.id
    //         addressError = false
    //       } else {
    //         // addressId = this.$store.state.user.storeDefaultAddress.id
    //         addressError = true
    //       }
    //       await this.setCartItemSample(item, addressId, item.person, addressError)
    //     }
    //     a++
    //   }
    //   if (a == value.length) {
    //     console.log('修改完成后')
    //     if (this.loading) {
    //       this.loading.close()
    //     }
    //     window.removeEventListener('beforeunload', this.handleBeforeUnload)
    //   }
    //   // })
    //   // const promises = tableList.map(async data => {
    //   //   console.log('data', data)
    //   //   if (!data.address?.id) {
    //   //     let address = await saveDimAddressFromExcel(data.address)
    //   //     if (address.data.success) {
    //   //       // 购物车里批量修改地址才走这个接口
    //   //       if (address.data.data.id && data.itemSpuId) {
    //   //         await cartItemSpuChangeAddress({
    //   //           addressId: address.data.data.id,
    //   //           itemSpuId: data.itemSpuId,
    //   //           params: { addressId: address.data.data.id }
    //   //         }).then(res => {
    //   //           // if (res.data.success) {
    //   //           //   this.$notify({
    //   //           //     title: '成功',
    //   //           //     message: '地址修改成功',
    //   //           //     type: 'success'
    //   //           //   })
    //   //           // }
    //   //         })
    //   //       }
    //   //       return {
    //   //         ...data,
    //   //         address: address.data.data,
    //   //         IsTrue: 1
    //   //       }
    //   //     } else {
    //   //       return {
    //   //         ...data,
    //   //         address: data.oldAddress,
    //   //         IsTrue: 2
    //   //       }
    //   //     }
    //   //   } else {
    //   //     return {
    //   //       ...data,
    //   //       IsTrue: 1
    //   //     }
    //   //   }
    //   // })
    //   // Promise.all(promises).then(posts => {
    //   //   console.log('posts', posts)
    //   //   this.selectList = posts
    //   // }).catch(function (reason) {
    //   //   console.log('出错了', reason)
    //   // })
    // },
    // 在线设计产品上传的excel数据
    // filechangeOnLine (value) {
    //   console.log('在线设计', value)
    //   let tableList = this.selectList
    //   // value.forEach(item => {
    //   for (let i in value) {
    //     let item = value[i]
    //     tableList = tableList.map((res) => {
    //       console.log('res-tableList', res.name, item.name)
    //       // 找打一样的名称并且该条信息注册过地址，直接将地址替换 && res.address?.completeAddress !== item.completeAddress
    //       if (res.name === item.name) {
    //         console.log('res-tableList', res)
    //         return {
    //           ...res,
    //           oldAddress: res.address,
    //           address: item
    //         }
    //       } else {
    //         return res
    //       }
    //     })
    //   }
    //   // })
    //   const promises = tableList.map(async data => {
    //     console.log('data', data)
    //     if (!data.address?.id) {
    //       let address = await saveDimAddressFromExcel(data.address)
    //       if (address.data.success) {
    //         // 购物车里批量修改地址才走这个接口
    //         if (address.data.data.id && data.itemSpuId) {
    //           await cartItemSpuChangeAddress({
    //             addressId: address.data.data.id,
    //             itemSpuId: data.itemSpuId,
    //             params: { addressId: address.data.data.id }
    //           }).then(res => {
    //             // if (res.data.success) {
    //             //   this.$notify({
    //             //     title: '成功',
    //             //     message: '地址修改成功',
    //             //     type: 'success'
    //             //   })
    //             // }
    //           })
    //         }
    //         return {
    //           ...data,
    //           address: address.data.data,
    //           IsTrue: 1
    //         }
    //       } else {
    //         return {
    //           ...data,
    //           address: data.oldAddress,
    //           IsTrue: 2
    //         }
    //       }
    //     } else {
    //       return {
    //         ...data,
    //         IsTrue: 1
    //       }
    //     }
    //   })
    //   Promise.all(promises).then(posts => {
    //     console.log('posts', posts)
    //     this.selectList = posts
    //   }).catch(function (reason) {
    //     console.log('出错了', reason)
    //   })
    // }
  },
  beforeDestroy () {
    if (this.loading) {
      this.loading.close()
    }
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import 'styles';

@deep: ~'>>>';

.edit-outline {
  display: flex;
  align-items: center;

  img {
    width: 14px;
    height: 14px;
    margin-right: 3px;
  }
}

.elUpload {
  box-sizing: border-box;
  width: 112px;
  height: 112px;
  // background: orange;
  text-align: center;
  line-height: 112px;
  font-size: 20px;
  border: 1px solid #000;
}

@{deep} .el-table__expanded-cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/deep/ .el-table__cell {
  line-height: 18px !important;
  padding: 12px 0 !important;
  border-bottom: none !important;
}

/deep/ .el-table__row {
  .el-table__cell {
    border-top: none !important;
    background: #efefef !important;
  }

  .error {
    background: #ffdede !important;
  }

  .success {
    background: #f2f2f2 !important;
  }
}
</style>
<style>
/* 操作栏居右 */
.right-align .cell {
  text-align: right !important;
}

.margin-align .cell {
  margin-left: 30px !important;
}

.color-blue-2 {
  font-size: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: left;
  color: #2973E2;
  height: 36px;
  line-height: 36px;
}

.editBtn {
  width: 58px;
  height: 25px;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #0E65FA;
  text-align: center;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #0E65FA;
  line-height: 25px;
  margin-left: 5px;
}
</style>
